import { Button, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { EMPLOYEE_WORKER } from '../../sagas/type'
import '../../scss/pages/Home/Home.scss'
import { getLocalStoreString } from '../../utils/Helper'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from "@mui/material/AppBar";
import DashBoard from './DashBoard/homeDashboard'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`
  };
}

function Home() {

  const dispatch = useDispatch()
  const [value, setValue] = useState(0);
  const state = useSelector(state => state);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className='homeContainer'>
      <Box >
        <div className='homeContainer_tabs-container' >
          <Tabs value={value} onChange={handleChange} >
            <Tab label="My Dashboard" {...a11yProps(0)} style={value == 0 ? { color: 'black', width: '10rem', padding: '5px', background: '#FFFFFF', borderRadius: '57px', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", padding: '5px', width: '10rem', }} />
            <Tab disabled label="Missions" {...a11yProps(1)} style={value == 1 ? { color: 'black', background: '#FFFFFF', width: '10rem', borderRadius: '57px', display: 'flex', alignItems: 'center', justifyContent: 'center' } : { color: 'white', display: 'flex', alignItems: 'center', justifyContent: "center", width: '10rem', }} />
          </Tabs>
        </div>

        <TabPanel value={value} index={0} >
          <DashBoard />
        </TabPanel>
        <TabPanel value={value} index={1} >
          Item Two
        </TabPanel>
      </Box>
    </div>
  )
}

export default Home

